var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _g, _path13, _g2, _path14, _g3, _path15, _g4, _g5, _path16, _path17, _path18, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgBoxIcon = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 186,
    height: 136,
    viewBox: "0 0 186 136",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M151.648 58.7265C151.648 71.9542 147.219 84.3837 139.837 94.1904C135.748 99.5499 130.865 104.225 125.187 107.874C116.101 113.918 105.086 117.339 93.3882 117.339C61.249 117.453 35.1288 91.2256 35.1288 58.7265C35.1288 26.3414 61.1355 0 93.3882 0C105.086 0 115.988 3.42096 125.187 9.46466C130.865 13.1137 135.748 17.789 139.837 23.1485C147.219 33.0693 151.648 45.3847 151.648 58.7265Z",
    fill: "#EAEEF9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M49.0197 50.8743H48.3164C47.7889 50.8743 47.4372 50.7102 47.4372 50.464C47.4372 50.2178 47.7889 50.0537 48.3164 50.0537H49.0197C49.5472 50.0537 49.8989 50.2178 49.8989 50.464C49.8989 50.7102 49.5472 50.8743 49.0197 50.8743Z",
    fill: "#2D5887"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M49.0197 54.1565H48.3164C47.7889 54.1565 47.4372 53.9924 47.4372 53.7462C47.4372 53.5 47.7889 53.3359 48.3164 53.3359H49.0197C49.5472 53.3359 49.8989 53.5 49.8989 53.7462C49.8989 53.9924 49.5472 54.1565 49.0197 54.1565Z",
    fill: "#2D5887"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M49.0197 57.4387H48.3164C47.7889 57.4387 47.4372 57.2746 47.4372 57.0284C47.4372 56.7823 47.7889 56.6182 48.3164 56.6182H49.0197C49.5472 56.6182 49.8989 56.7823 49.8989 57.0284C49.8989 57.2746 49.5472 57.4387 49.0197 57.4387Z",
    fill: "#2D5887"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M49.0197 60.7209H48.3164C47.7889 60.7209 47.4372 60.5568 47.4372 60.3107C47.4372 60.0645 47.7889 59.9004 48.3164 59.9004H49.0197C49.5472 59.9004 49.8989 60.0645 49.8989 60.3107C49.8989 60.5568 49.5472 60.7209 49.0197 60.7209Z",
    fill: "#2D5887"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M81.119 50.8743H69.5531C69.0842 50.8743 68.7716 50.7102 68.7716 50.464C68.7716 50.2178 69.0842 50.0537 69.5531 50.0537H81.119C81.5879 50.0537 81.9005 50.2178 81.9005 50.464C81.9005 50.7102 81.5879 50.8743 81.119 50.8743Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M105.762 60.7209H69.5265C69.0736 60.7209 68.7716 60.5568 68.7716 60.3107C68.7716 60.0645 69.0736 59.9004 69.5265 59.9004H105.762C106.215 59.9004 106.517 60.0645 106.517 60.3107C106.517 60.5568 106.215 60.7209 105.762 60.7209Z",
    fill: "url(#paint0_linear_14713_114850)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M81.1641 54.1565H65.4052C64.9634 54.1565 64.6688 53.9924 64.6688 53.7462C64.6688 53.5 64.9634 53.3359 65.4052 53.3359H81.1641C81.6059 53.3359 81.9005 53.5 81.9005 53.7462C81.9005 53.9924 81.6059 54.1565 81.1641 54.1565Z",
    fill: "#2D5887"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M93.474 57.4387H65.4036C64.9628 57.4387 64.6688 57.2746 64.6688 57.0284C64.6688 56.7823 64.9628 56.6182 65.4036 56.6182H93.474C93.9149 56.6182 94.2088 56.7823 94.2088 57.0284C94.0618 57.2746 93.7679 57.4387 93.474 57.4387Z",
    fill: "#2D5887"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M105.718 57.4387H95.008C94.5285 57.4387 94.2088 57.2746 94.2088 57.0284C94.2088 56.7823 94.5285 56.6182 95.008 56.6182H105.718C106.197 56.6182 106.517 56.7823 106.517 57.0284C106.517 57.2746 106.197 57.4387 105.718 57.4387Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M112.305 57.4387H108.114C107.648 57.4387 107.338 57.2746 107.338 57.0284C107.338 56.7823 107.648 56.6182 108.114 56.6182H112.305C112.771 56.6182 113.082 56.7823 113.082 57.0284C113.082 57.2746 112.771 57.4387 112.305 57.4387Z",
    fill: "url(#paint1_linear_14713_114850)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M22 102.569H159.853",
    stroke: "#D6DEE8",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_14713_114850)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M118.825 50.0537V102.569H44.3714C41.4344 102.569 39.2316 100.209 39.2316 97.4062V50.0537H118.825Z",
    fill: "white"
  }))), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M148.365 50.0537V97.4062C148.365 100.356 145.916 102.569 143.008 102.569H118.825V50.0537H148.365Z",
    fill: "#DAE1ED"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_14713_114850)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M148.365 50.0537V97.4062C148.365 100.356 145.916 102.569 143.008 102.569H118.825V50.0537H148.365Z",
    fill: "#E7EAF4"
  }))), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M67.951 50.0539L83.6072 25.4373H163.956L147.857 50.0539H67.951Z",
    fill: "#C5CDDB"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_14713_114850)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M67.951 50.0539L83.6072 25.4373H163.956L147.857 50.0539H67.951Z",
    fill: "url(#paint2_linear_14713_114850)"
  }))), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M148.365 50.1975V77.9526H126.826C124.826 77.9526 123.441 76.6583 123.133 74.7888L118.825 50.0537L148.365 50.1975Z",
    fill: "url(#paint3_linear_14713_114850)"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_d_14713_114850)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M147.746 50.0537H118.825L133.511 72.3119C134.56 73.7859 136.208 74.6704 137.856 74.6704H160.334C161.832 74.6704 162.881 72.9015 161.982 71.7223L147.746 50.0537Z",
    fill: "url(#paint4_linear_14713_114850)"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_d_14713_114850)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M118.825 50.0539L103.06 25.4373H22L38.3607 50.0539H118.825Z",
    fill: "#E7EAF4"
  }))), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M78.9543 80.4143H47.9217C47.1967 80.4143 46.6166 79.8673 46.6166 79.1835C46.6166 78.4997 47.1967 77.9526 47.9217 77.9526H78.9543C79.6793 77.9526 80.2594 78.4997 80.2594 79.1835C80.1144 79.8673 79.6793 80.4143 78.9543 80.4143Z",
    fill: "#DAE1ED"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M78.9543 86.1582H47.9217C47.1967 86.1582 46.6166 85.7935 46.6166 85.3376C46.6166 84.8818 47.1967 84.5171 47.9217 84.5171H78.9543C79.6793 84.5171 80.2594 84.8818 80.2594 85.3376C80.1144 85.7935 79.6793 86.1582 78.9543 86.1582Z",
    fill: "#DAE1ED"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M62.5228 92.7227H47.9422C47.2058 92.7227 46.6166 92.358 46.6166 91.9021C46.6166 91.4462 47.2058 91.0815 47.9422 91.0815H62.5228C63.2592 91.0815 63.8483 91.4462 63.8483 91.9021C63.701 92.358 63.1119 92.7227 62.5228 92.7227Z",
    fill: "#DAE1ED"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_14713_114850",
    x: 17.2316,
    y: 39.0537,
    width: 123.594,
    height: 96.5154,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 11
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 11
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.397708 0 0 0 0 0.47749 0 0 0 0 0.575 0 0 0 0.27 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_14713_114850"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_14713_114850",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_14713_114850",
    x: 96.8254,
    y: 39.0537,
    width: 73.54,
    height: 96.5154,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 11
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 11
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.397708 0 0 0 0 0.47749 0 0 0 0 0.575 0 0 0 0.27 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_14713_114850"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_14713_114850",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_14713_114850",
    x: 45.951,
    y: 14.4373,
    width: 140.005,
    height: 68.6167,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 11
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 11
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.397708 0 0 0 0 0.47749 0 0 0 0 0.575 0 0 0 0.27 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_14713_114850"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_14713_114850",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_d_14713_114850",
    x: 96.8254,
    y: 39.0537,
    width: 87.4894,
    height: 68.6167,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 11
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 11
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.397708 0 0 0 0 0.47749 0 0 0 0 0.575 0 0 0 0.27 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_14713_114850"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_14713_114850",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_d_14713_114850",
    x: 0,
    y: 14.4373,
    width: 140.825,
    height: 68.6167,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 11
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 11
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.397708 0 0 0 0 0.47749 0 0 0 0 0.575 0 0 0 0.27 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_14713_114850"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_14713_114850",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_14713_114850",
    x1: 68.9412,
    y1: 60.3273,
    x2: 106.561,
    y2: 60.3273,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF66A9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F53689"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_14713_114850",
    x1: 107.376,
    y1: 57.0033,
    x2: 113.081,
    y2: 57.0033,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#83A6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A78FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_14713_114850",
    x1: 115.922,
    y1: 24.8678,
    x2: 115.922,
    y2: 50.3193,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDFEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    stopColor: "#ECF0F5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_14713_114850",
    x1: 133.602,
    y1: 78.5252,
    x2: 133.602,
    y2: 53.1127,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00289017,
    stopColor: "#606673",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AAB2C5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_14713_114850",
    x1: 140.556,
    y1: 49.4843,
    x2: 140.556,
    y2: 74.9357,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDFEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    stopColor: "#ECF0F5"
  })))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgBoxIcon, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/box-icon.b6dc8ddb.svg";
export { ForwardRef as ReactComponent };